export function getDashedURL(url) {
  return url.replace(/ +/g, '-');
}
export default function getSpacedFromDashedURL(url) {
  // backwards compatibility
  return url.replace(/-/g, ' ');
}
